module.exports = __webpack_public_path__ + "img/C08TechVanisHaste_ua.455ab973.webp";